import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Title from '../../components/Header/parts/Title';

const LogoList = styled.ul`
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  align-content: center;
  justify-content: center;
  justify-items: center;
  padding: 4rem 2.4rem;
`;
const LogoItem = styled.li`
  display: flex;
  flex-direction: column;
  align-items: center;
  align-content: center;
  justify-content: center;
  justify-items: center;
  max-width: 25vw;

  padding: 2.4rem;
  flex-grow: 1;
  flex-shrink: 0;
`;

const HeroLogos = ({ input }) => {
  console.log(input);

  const logos = input.items.map(({ logo }) => {
    //console.log(logo);
    const asset = logo.Medium;
    return (
      <LogoItem key={asset.url}>
        <img
          src={asset.url}
          alt={logo.alt ? logo.alt : 'Company Logo'}
          width={asset.dimensions.width}
          height={asset.dimensions.height}
        />
      </LogoItem>
    );
  });

  return (
    <>
      <Title
        title={input.primary.title.html}
        subtitle={input.primary.subtitle.html}
        description={input.primary.description.html}
        title_align={input.primary.align_text}
      />
      <LogoList>{logos}</LogoList>
    </>
  );
};

HeroLogos.propTypes = {
  input: PropTypes.object.isRequired,
};

export default HeroLogos;
